import { Topbar } from '../../components/Topbar/Topbar';
import { Badge, Button, Container, ListGroup } from 'react-bootstrap';
import { Footer } from '../../components/Footer/Footer';
import { useFirebase } from '../../../contexts/FirebaseContext';
import { useEffect, useState } from 'react';
import { UserUID } from '../../components/UserUID/UserUID';
import { formatSecondsTimestamp } from '../../utils/utils';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCheckSquare, faCircleNotch } from '@fortawesome/free-solid-svg-icons';
import { faSquare } from '@fortawesome/free-regular-svg-icons';
import { Copyable } from '../../components/Copyable/Copyable';
import { Title } from '../../components/Title/Title';

const VideoReportsComponent = () => {
  const { getVideoReports, database } = useFirebase();

  const [loading, setLoading] = useState(false);
  const [ackLoading, setAckLoading] = useState(false);
  const [ackLoadingId, setAckLoadingId] = useState(null);
  const [videoReports, setVideoReports] = useState([]);

  useEffect(() => {
    setLoading(true);
    getVideoReports()
      .then(({ reports }) => setVideoReports(reports))
      .catch(console.error)
      .finally(() => setLoading(false));
  }, []);

  return (
    <>
      <Title>Segnalazioni video</Title>

      <div style={{ marginBottom: '72px' }}>
        <div style={{ backgroundColor: '#141414', position: 'fixed', top: '0', left: '0', right: '0', zIndex: 100 }}>
          <Topbar />
        </div>
      </div>

      <Container className={'my-5'}>
        <div className={'d-flex align-items-center'}>
          <div className={'display-4'}>Segnalazioni video</div>
        </div>
        <ListGroup className={'mt-4'}>
          {loading && <div className={'text-center'}>Caricamento in corso...</div>}

          {!loading && !videoReports.length && <div className={'text-center'}>Nessuna segnalazione.</div>}

          {!loading &&
            videoReports.map((report) => (
              <ListGroup.Item key={report.id} variant={'dark'} className={'dark-list-item'}>
                <div className={'d-flex justify-content-between'}>
                  <div>
                    Inviato da <UserUID uid={report.uid} /> il {formatSecondsTimestamp(report.ts._seconds, 'dd/MM/Y HH:mm')}
                  </div>
                  <div>
                    <small>
                      <Copyable text={report.id} />
                    </small>
                    <Button
                      className={'ml-2'}
                      variant={report.ack ? 'success' : 'warning'}
                      size={'sm'}
                      disabled={ackLoading}
                      onClick={() => {
                        setAckLoading(true);
                        setAckLoadingId(report.id);
                        database
                          .doc(`videoReports/${report.id}`)
                          .update({ ack: !report.ack })
                          .then(() => {
                            report.ack = !report.ack;
                          })
                          .catch(console.error)
                          .finally(() => {
                            setAckLoading(false);
                            setAckLoadingId(null);
                          });
                      }}
                    >
                      <FontAwesomeIcon
                        spin={report.id == ackLoadingId}
                        icon={report.id == ackLoadingId ? faCircleNotch : report.ack ? faCheckSquare : faSquare}
                        className={'mr-2'}
                      />
                      Ack
                    </Button>
                  </div>
                </div>
                <div>
                  Problemi rilevati:
                  {report.types.map((type) => (
                    <Badge variant={'secondary'} key={type} className={'ml-1'}>
                      {type.toUpperCase()}
                    </Badge>
                  ))}
                </div>
                <div>
                  Sul video "<strong>{report.video.title || '[RIMOSSO]'}</strong>" (<Copyable text={report.video.id} />)
                </div>
                <div>
                  di {report.video.author.name || '[RIMOSSO]'} a secondi <strong>{report.time}</strong>
                </div>
                <div className={'border-left rounded pl-2 my-1 py-1'} style={{ backgroundColor: 'rgba(255,255,255,0.1)' }}>
                  {report.details || 'Nessuna descrizione fornita.'}
                </div>
                <details>
                  <summary>Dettagli tecnici</summary>
                  <pre className={'mb-0'}>{JSON.stringify({ platform: report.platform, ua: report.ua, config: report.config }, null, 2)}</pre>
                </details>
              </ListGroup.Item>
            ))}
        </ListGroup>
      </Container>

      <Footer />
    </>
  );
};

export default VideoReportsComponent;
